import { render, staticRenderFns } from "./Vie.vue?vue&type=template&id=6abe7da1&scoped=true"
import script from "./Vie.vue?vue&type=script&lang=js"
export * from "./Vie.vue?vue&type=script&lang=js"
import style0 from "./Vie.vue?vue&type=style&index=0&id=6abe7da1&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abe7da1",
  null
  
)

export default component.exports